import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, Stack, Divider, Paper } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { get } from "lodash";
import { questionKeyLabels } from "../../../../config";

export type Diff = {
  diff: string;
  questionId: string;
  excel: string;
  addIn: string;
};

type Props = {
  items: Diff[];
  isResolved?: boolean; // 追加: isResolved プロパティ
};

const MyCarousel = (props: Props) => {
  const { items, isResolved } = props;

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : items.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < items.length - 1 ? prev + 1 : 0));
  };

  const item = items.length ? items[currentIndex] : null;

  if (!item || isResolved) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        maxWidth="600px"
        p={1}
      >
        <Typography variant="body_M">差分は見つかりませんでした。</Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      maxWidth="600px"
      p={1}
    >
      <Box display="flex" alignItems="center" justifyContent="center" width="100%">
        <IconButton onClick={handlePrev}>
          <ArrowBackIos />
        </IconButton>

        <Stack
          flex={1}
          direction={"column"}
          minHeight="100px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={2}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            transition: "transform 0.5s ease-in-out",
          }}
        >
          <Typography
            variant="body_L"
            marginBottom={2}
          >{`${item.questionId} ${get(questionKeyLabels, item.diff, item.diff)}`}</Typography>

          <Stack direction={"column"} spacing={1} paddingX={2} width={360}>
            <Stack width={"100%"} padding={1}>
              <Typography variant="label_M" fontWeight={600} marginBottom={1}>
                Excel
              </Typography>
              <Typography variant="body_S" sx={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                {item.excel || "なし"}
              </Typography>
            </Stack>
            <Divider flexItem />

            <Stack width={"100%"} padding={1}>
              <Typography variant="label_M" fontWeight={600} marginBottom={1}>
                Add-in
              </Typography>
              <Typography variant="body_S" sx={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                {item.addIn || "なし"}
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        <IconButton onClick={handleNext}>
          <ArrowForwardIos />
        </IconButton>
      </Box>

      {/* インジケーター */}
      <Box display="flex" mt={2} gap={1}>
        {items.map((_, index) => (
          <Box
            key={index}
            width={10}
            height={10}
            borderRadius="50%"
            bgcolor={index === currentIndex ? "primary.main" : "grey.400"}
          />
        ))}
      </Box>
    </Box>
  );
};

export default MyCarousel;
